import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

class Adminfooter extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				{
					this.props.isNoticePopup &&
					(
						<div className="position-fixed bottom-0 right-0 p-3" style={{"zIndex": "5", "right": "0", "bottom": "0"}}>
							<div id="liveToast" className="toast" role="alert" aria-live="assertive" aria-atomic="true"
							     data-delay="2000" style={{"opacity": "1"}}>
								<div className="toast-header">
									<strong className="mr-auto">알림</strong>
									{/*<small>11 mins ago</small>*/}
									{/*<button type="button" className="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">*/}
									{/*	<span aria-hidden="true">&times;</span>*/}
									{/*</button>*/}
								</div>
								<div className="toast-body">
									{this.props.noticeMessage}
								</div>
							</div>
						</div>
					)
				}
			</>
		)
	}
};

export default connect(
	(state) => ({
		isNoticePopup: state.footer.isNoticePopup ? state.footer.isNoticePopup : '',
		noticeMessage: state.footer.noticeMessage ? state.footer.noticeMessage : '',
	}),
	(dispatch) => ({
		// fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(Adminfooter)
